import { faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';

import Card from '../../ui/components/Card';
import Heading from '../../ui/components/Heading';
import Tooltip from '../../ui/components/Tooltip';

import { Props } from './types';

const DrugScreenBanner = ({ program, substances, compliantResult, drugScreenCounts }: Props) => {
  return (
    <Card className="flex flex-col gap-4">
      <div>
        <Heading className="text-gray-500" value={6} text="Program" />
        <Heading className={'capitalize'} value={3} text={program} />
      </div>
      <div>
        <Heading className={'text-gray-500'} value={6} text={'Target Substance for CM'} />
        <div>
          <Heading className="mp-sensitive capitalize" value={3} text={substances.join(', ')} />
        </div>
        <div className="ml-2">
          <ul className="list-disc list-inside">
            <li className="text-gray-900 font-medium">Positive: {drugScreenCounts.positive}</li>
            <li className="text-gray-900 font-medium">Negative: {drugScreenCounts.negative}</li>
            <li className="text-gray-900 font-medium">
              Total including missed: {drugScreenCounts.total}
            </li>
          </ul>
        </div>
      </div>
      <div>
        <Heading className={'text-gray-500'} value={6} text={'Desired Result for CM'}>
          <Tooltip
            tooltipContent={
              'Compliant means that the result of the test matches our expected result for that program and therefore the member may receive a CM reward if they are eligible.'
            }>
            <FontAwesomeIcon icon={faInfoCircle} />
          </Tooltip>
        </Heading>
        <Heading value={3} text={compliantResult} />
      </div>
    </Card>
  );
};

export default DrugScreenBanner;
